import { Injectable, signal, computed } from '@angular/core';

/**
 * Lightweight service to track whether a user detail view is active.
 * Set by UserDetailLayoutComponent on init/destroy.
 * Read by HomeNavComponent for quick-switch popover display.
 */
@Injectable({ providedIn: 'root' })
export class UserDetailContextService {
  readonly activeUserId = signal<string | null>(null);
  readonly activeSectionId = signal<string | null>(null);
  readonly isActive = computed(() => this.activeUserId() !== null);

  activate(userId: string, sectionId: string): void {
    this.activeUserId.set(userId);
    this.activeSectionId.set(sectionId);
  }

  deactivate(): void {
    this.activeUserId.set(null);
    this.activeSectionId.set(null);
  }

  /** Update user ID without deactivating (for quick switching) */
  switchUser(userId: string): void {
    this.activeUserId.set(userId);
  }
}
